const { default: axios } = require("axios");
var IBAN = require('iban');

// https://github.com/mattickx/jsvat-next
import { checkVAT, countries } from 'jsvat-next';

export default {
  data() {
    return {
      vincoli: {
        required: v => v !== null && v !== "" || "Campo obbligatorio",
        checkboxRequired: value => !!value || 'È obbligatorio spuntare la casella',
        username: v => v && v.length >= 4 || "Username troppo corto (Min. 4 caratteri)",
        password: v => !v || v.length >= 6 && v.length <= 12 || "La password deve essere lunga minimo 6 caratteri e massimo 12",
        email: v => !v || /.+@.+/.test(v) || "Email non valida",
        accettoCondizioni: v => v == true || 'Accetta le Condizioni Generali',
        teamName: v => v !== null && v.length >= 4 && v.length <= 24 || "Nome del Team non valido (Min. 4 caratteri - Max. 24 caratteri)",
        isNumber: v => !isNaN(v) || "Non è un numero",
        isNumberLessThan60: v => v && !isNaN(v) && v <= 60 || "Tempo non valido. Esempio formato: 7.42 (max 60 Secondi)",

        // codiceAziendale: v => v===window.__CODICE_AZIENDALE__ || "Codice aziendale errato!",
        // captcha: v => v===this.cypherAlgo(window.__SIMULAZIONE__.risposta, true) || "Captcha errato!",
        multiselectRequired: (v) =>  v.length>0 || "Campo obbligatorio", // <v-select> con prop 'multiple'
        notEmail: v => {
					if (/.+@.+/.test(v)) {
		        return `L'username non può essere un indirizzo email`;
		      } else {
						return true;
		      }
        },
        iban: v => IBAN.isValid(v) || "L'IBAN inserito non è corretto",
        unsignedSmallInteger: v => v <= 65535 || "Valore massimo: 65535",
        codice_fiscale: v => !v || v === '' || /^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$/.test(v.trim()) || "Codice fiscale non valido",
        numero_di_emergenza: v => !v || /^[0-9+\-/\s]+$/.test(v) || "Numero di emergenza non valido, sono consentiti solo i seguenti caratteri: cifre da 0 a 9, +, -, / e spazi vuoti",
        numero_cellulare_cl: v => !v || /^[0-9+\-/\s]+$/.test(v) && v.length >= 7 || "Numero di cellulare non valido, sono consentiti solo i seguenti caratteri: almeno 7 cifre da 0 a 9, +, -, / e spazi vuoti",
        partita_iva: v => !v
          || checkVAT(v, countries).isValid
          || 'Partita IVA non valida',
        data_ora_italia: v =>
          !v ||
          /^(0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/\d{4} ([01]\d|2[0-3]):[0-5]\d$/.test(v) ||
          "Data e ora non valide, il formato richiesto è il seguente: gg/mm/aaaa hh:mm",
        
      },

      inailColor: "#042C5A",
      scdColor: "#6D94CD",
      scdColorStrong: '#347de8',
	    scdColorDarkBlue: '#3c4f6b',
      // scdOrange: "#F08339",
      scdOrange: "#e6901c",
      scdLightOrange: "#EE9960",
	    scdLightRed: '#f30202',
	    scdRed: '#bc2025',
      scdGreen: '#8bba40',
      scdYellow: '#fcc900',

      // La stessa mappa è presente anche BACKEND (Controller Simulazione):
      cypherMap: {
        a: 'q',
        b: 'w',
        c: 'e',
        d: 'r',
        e: 't',
        f: 'y',
        g: 'u',
        h: 'i',
        i: 'o',
        j: 'p',
        k: 'a',
        l: 's',
        m: 'd',
        n: 'f',
        o: 'g',
        p: 'h',
        q: 'j',
        r: 'k',
        s: 'l',
        t: 'z',
        u: 'x',
        v: 'c',
        w: 'v',
        x: 'b',
        y: 'n',
        z: 'm',
        '0': '1',
        '1': '7',
        '2': '5',
        '3': '9',
        '4': '2',
        '5': '6',
        '6': '3',
        '7': '0',
        '8': '4',
        '9': '8',
      },

      // ========= GAMING =========
      livelliGaming: [
        {
          "livello": 0,
          "soglia_percentuale": 0,
          "bonus_perdita": 0,
          "bonus_vittoria": 0
        },
        {
          "livello": 1,
          "soglia_percentuale": 25,
          "bonus_perdita": 5,
          "bonus_vittoria": 10
        },
        {
          "livello": 2,
          "soglia_percentuale": 40,
          "bonus_perdita": 10,
          "bonus_vittoria": 25
        },
        {
          "livello": 3,
          "soglia_percentuale": 55,
          "bonus_perdita": 20,
          "bonus_vittoria": 45
        },
        {
          "livello": 4,
          "soglia_percentuale": 60,
          "bonus_perdita": 30,
          "bonus_vittoria": 75
        },
        {
          "livello": 5,
          "soglia_percentuale": 65,
          "bonus_perdita": 45,
          "bonus_vittoria": 115
        },
        {
          "livello": 6,
          "soglia_percentuale": 75,
          "bonus_perdita": 60,
          "bonus_vittoria": 160
        },
        {
          "livello": 7,
          "soglia_percentuale": 85,
          "bonus_perdita": 80,
          "bonus_vittoria": 220
        },
        {
          "livello": 8,
          "soglia_percentuale": 95,
          "bonus_perdita": 100,
          "bonus_vittoria": 300
        }
			],
      
      minimumBrowsersVersionsData: {
        browser_version_checking_enabled: false,
        firefox: null,
        chrome: null,
        edge: null
      }
    }
  },
   methods: {
    shuffleArray(array){ // Funzione per eseguire lo shuffle di un array
      array = JSON.parse(JSON.stringify(array)) // Creo un clone dell'array per non modificare l'originale
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    },

     getLivello: function (migliorPunteggio) {
       var data = {};
       
       if (migliorPunteggio === null || migliorPunteggio === -1) {
         data.livello = 0;
         data.bonusPerdita = 0;
         data.bonusVittoria = 0;
       }
			 else {
         for (let object of this.livelliGaming) {
           if (migliorPunteggio >= object.soglia_percentuale) {
             data.livello = object.livello;
             data.bonusPerdita = object.bonus_perdita;
             data.bonusVittoria = object.bonus_vittoria;
           }
         }
       }

       return data;
     },
     cypherAlgo: function (toParse, isDecode) {
       let cypherMapSafeCopy = Object.assign({}, this.cypherMap);

       // Flip the cypherMap
       if (isDecode) {
         cypherMapSafeCopy = (function () {
           var tmp = {};
           var k;

           // Populate the tmp variable
           for (k in cypherMapSafeCopy) {
             if (!cypherMapSafeCopy.hasOwnProperty(k)) continue;
             tmp[cypherMapSafeCopy[k]] = k;
           }

           return tmp;
         })();
       }

       // La funzione di Encoding non viene mai utilizzata (encoding effettuato lato Server);
       return toParse.split('').map(function (v) {
         if (cypherMapSafeCopy.hasOwnProperty(v.toLowerCase())) {
           if (v == v.toUpperCase()) {
             // Se è maiuscolo restituisco il maiuscolo
             return cypherMapSafeCopy[v.toLowerCase()].toUpperCase();
           }
           return cypherMapSafeCopy[v.toLowerCase()].toLowerCase();
         } else {
           return v;
         }
       }).join("");
     },
     numberWithDots(x) {
       // Separa le migliaia con la virgola
       return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
     },
     dateSTDFormat(date){
       if (!date) return null
       const [day, month, year] = date.split('/');
       return `${year}-${month}-${day}`;
     },
     dateITFormat(date){
       if (!date) return null
       const [year, month, day] = date.split('-');
       let yy = year.substr(-2);
       return `${day}/${month}/${yy}`;
     },
     dateITFormatDDMMYYYY(date){
       if (!date) return null
       const [year, month, day] = date.split('-');
       // let yy = year.substr(-2);
       return `${day}/${month}/${year}`;
     },
     computedDateWithoutTime: function(datetime) {
      return moment(datetime).format("DD/MM/YYYY");
    },
     computedTime: function(datetime) {
       return datetime.split(" ")[1];
     },
	   computedTimeWithoutSeconds: function(datetime) {
		   return moment(datetime).format("HH:mm");
	   },
     computedDateTime: function(datetime){
			 return moment(datetime).format("DD/MM/YYYY HH:mm:ss");
     },
     computedDateTimeWithoutSeconds: function(datetime){
       let dataObj = moment(datetime)
       if(!dataObj.isValid()){
          return null;
       } else {
         return dataObj.format("DD/MM/YYYY HH:mm");
       }
     },
     getNumeroRandom(min, max) {
         return Math.floor(Math.random() * (max - min + 1) + min)
     },
     replaceAtIndex(string, index, replacement) { // sostituisce l'elemento alla posizione 'index' di 'string' inserendo 'replacement'
       // console.log('stringa', string);
       // console.log('replacement length', replacement.length);
       // console.log('replacement', replacement);
       // console.log('index + replacement length', index + replacement.length);
       // console.log('strSx', string.substr(0, index));
       // console.log('replacement', replacement);
       // console.log('strDx', string.substr(index + replacement.length));

       return string.substr(0, index) + replacement + string.substr(index + replacement.length);
     },
     popUpDatiCliccatore(idCliccatore = null, aperturaDaTabellaCliccatori = false) {
       // == Tab ==
       // let a = document.createElement('a');
       // a.target='_blank';
       // a.href='datiCliccatore/';
       // a.click();

       // == Popup ==
       // var w = 360;
       const w = 505;
       const h = 700;
       
       let l;
       let t;
       
       if (aperturaDaTabellaCliccatori) {
         l = Math.floor((screen.width - w) / 2); // distanza dal bordo sinistro dello schermo
         t = Math.floor((screen.height - h) / 2);
       }
       else {
         l = 0;
         t = 0;
       }

       if (idCliccatore == null) { // apre finestra dalla pagina SIMULAZIONI
           window.open(
             `/datiCliccatore`,
             "",
             "width=" + w + ",height=" + h + ",top=" + t + ",left=" + l
           );
       }
       else { // apre finestra dalla pagina CLICCATORI
           window.open(
             `/datiCliccatore/${idCliccatore}`,
             "",
             "width=" + w + ",height=" + h + ",top=" + t + ",left=" + l
           );
       }
		},
	   manutenzioneAttiva() {
			 return axios.get('/manutenzione_attiva')
       // .then(response => {
       //     console.log(response.data);
       //     return response.data
       // })
     },
     getMinimumBrowsersVersionsData() {
       return axios.get('/bandi/minimum-browsers-versions-data')
         .then(response => {
           this.minimumBrowsersVersionsData = response.data;
           console.log(this.minimumBrowsersVersionsData);
         })
     },
     isTheBrowserCompatible() {
       let userAgent = navigator.userAgent;
       let browser, version;
       
       if (userAgent.indexOf("OPR") > -1 || userAgent.indexOf("Chromium") > -1) {
         return false; // Escludiamo Opera e Chromium
       } else if (userAgent.indexOf("Chrome") > -1) {
         browser = "Chrome";
         version = parseInt(userAgent.match(/Chrome\/(\d+)/)[1], 10);
       } else if (userAgent.indexOf("Edg") > -1) {
         browser = "Edge";
         version = parseInt(userAgent.match(/Edg\/(\d+)/)[1], 10);
       } else if (userAgent.indexOf("Firefox") > -1) {
         browser = "Firefox";
         version = parseInt(userAgent.match(/Firefox\/(\d+)/)[1], 10);
       } else {
         return false; // Browser non supportato
       }
       
       console.log(
         'Il browser è compatibile?',
         (browser === "Chrome" && version >= 125) ||
         (browser === "Edge" && version >= 125) ||
         (browser === "Firefox" && version >= 125)
       )
       
       return (browser === "Chrome" && version >= 125) ||
         (browser === "Edge" && version >= 125) ||
         (browser === "Firefox" && version >= 125);
     },
     customFilterByProperties(item, queryText, myProperties) {
       let found = false;
       // Scorro in un elenco di properties inserite da me
       myProperties.forEach(function(myProp){
         if(item[myProp] != null && item[myProp].toLowerCase().indexOf(queryText.toLowerCase()) > -1){
           found = true;
         }
       })
       
       return found;
     },

     generaUID() { // Funzione per generare un uid. Es: "f65c57f6-a6aa-4d3c-b1b2-3e1f4b8c9d2e"
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          const r = Math.random() * 16 | 0;
          const v = c === 'x' ? r : (r & 0x3 | 0x8);
          return v.toString(16);
        });
     }
   },
  computed: {
    computedUsername: function(){
			return window.__USERNAME__;
    },
    computedRuolo: function(){
			return window.__RUOLO__;
    },
    computedAmIAdmin: function(){
			return window.__RUOLO__ == 'Admin';
    },
    computedAmITeamleader: function(){
      return window.__RUOLO__ == 'Teamleader';
    },
    amIAdminOrTeamleader: function(){
			return window.__RUOLO__ == "Admin" || window.__RUOLO__ == "Teamleader";
    },
    amIProvaGratuita: function(){
			return window.__PROVA_GRATUITA__ == '1';
    },
    computedNomePacchetto: function() {
			return window.__NOME_PACCHETTO__;
    },
    computedHasTeamsEnabled: function(){
			return window.__TEAMS_ENABLED__ == '1';
    },
    // computedDatiCliccatoreEnabled: function(){
    //   return window.__DATI_CLICCATORE_ENABLED__ == '1';
    // },
    computedIdUtente: function(){
			return window.__ID_UTENTE__;
    },

    computedIsUtenteAttivo: function(){
			return window.__IS_UTENTE_ATTIVO__ == '1' || window.__IS_UTENTE_ATTIVO__ == 1;
    },

    computedClienteClickdayIt() {
			return window.__NOME_PACCHETTO__ == 'CLICKDAY'
        || window.__NOME_PACCHETTO__ == 'DEVELOPER'
        || window.__NOME_PACCHETTO__ == 'CLICKDAY_TEST';
    },
    computedAmIDeveloper() {
      return window.__NOME_PACCHETTO__ == 'DEVELOPER';
    },
    gamingAbilitato() {
			return window.__GAMING_ABILITATO__;
    },
    minimoSimulazioniSelezioneComputed() {
			return window.__MINIMO_SIMULAZIONI_SELEZIONE_CLICKDAYIT__;
    },
    computedBandoId() {
      return parseInt(window.__BANDO_ID__);
    }
  }
}
